import { Table } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { Photo } from './models/Photo';
import PhotoComponent from './PhotoComponent';

function Photos() {
  const [photos, setPhotos] = useState<Photo[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`/api/photos.json`)
      .then(res => res.json())
      .then(data => {
        setPhotos(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load photos:', err);
        setLoading(false);
      });
  }, []);

  return (
    <div>
      { loading ?
        <p></p>
        :
        <div className="container">
        <Table bordered>
          <tr>
          <th>Date</th>
          <th>Location</th>
          <th>Country</th>
          <th>Caption</th>
          <th>Image</th>
          </tr>
        { photos.map(photo =>
        <tr><td>{photo.date}</td><td>{photo.location}</td><td>{photo.country}</td><td><span dangerouslySetInnerHTML={{__html: photo.caption}}/></td><td>
          <PhotoComponent
            photoId={photo.id}
            photoLocation={photo.location}
            photoCaption={photo.caption}
            photoDate={photo.date}
            photoName={photo.name}
          /></td></tr>
        )
        
        }
        </Table>
        </div>
      }
    </div>
  );
};

export default Photos;
